export const QUICK_ACTIONS_POLLING_INTERVAL = 10000; // 10 seconds
